import {getTopics} from '../../services/ClientService.js';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    topicsList: [],
    currentTopic: {},
    virtualTopicCondition: false
  },
  getters: {
    topicsList: (state) => {
      return state.topicsList;
    },
    currentTopic: (state) => {
      return state.currentTopic;
    }
  },
  mutations: {
    setTopicsList (state, topics) {
      if (topics) {
        for (var topic of topics) {
          topic.latLng = JSON.parse(topic.latLng);
          topic.selected = false;
          topic.hover = false;
          topic.mapHover = false;
          topic.expanded = false;
        }
      }
      state.topicsList = topics;
    },
    removeMapTopicsFromState (state, index) {
      var topics = state.topicsList;
      for (var topic of topics) {
        topic.hover = false;
        topic.mapHover = false;
      }
      if (index === 0) {
        topics = topics.slice(1);
      } else if (index === topics.length - 1) {
        topics = topics.slice(0, topics.length - 1);
      } else {
        topics = topics.slice(0, index).concat(topics.slice(index + 1));
      }
      state.topicsList = topics;
    },
    setCurrentTopic (state, topic) {
      state.currentTopic = topic;
    },
    setMapHover (state, indexAndToggle) {
      var index = indexAndToggle[0];
      var toggle = indexAndToggle[1];
      state.topicsList[index].mapHover = toggle;
    },
    clearTopicsList (state) {
      state.topicsList = [];
    },
    toggleVirtualConditional (state, condition) {
      state.virtualTopicCondition = condition;
    },
    toggleTopicHover (state, payload) {
      // state.topicsList[payload.index].hover = payload.hover;
      let topics = state.topicsList;
      topics[payload.index].hover = payload.hover;
      state.topicsList = topics;
    },
    resetSelectedTopics (state) {
      for (let topic of state.topicsList) {
        topic.selected = false;
      }
    },
    resetTopicHover (state) {
      for (let topic of state.topicsList) {
        topic.hover = false;
        topic.mapHover = false;
      }
    },
    clearCurrentTopic (state) {
      state.currentTopic = {};
    },
    alphaSortTopics (state) {
      state.topicsList = Vue._.sortBy(state.topicsList, ['name']);
    }
  },
  actions: {
    async loadTopics ({commit}, tourId) {
      commit('clearTopicsList');
      const response = await getTopics(tourId);
      if (response.status === 200) {
        commit('setTopicsList', response.data);
      }
    },
    loadEditorTopic ({commit, state}, topic) {
      commit('setCurrentTopic', topic);
    },
    setMapHover ({commit}, indexAndToggle) {
      commit('setMapHover', indexAndToggle);
    },
    setTopicsList ({commit}, topicList) {
      commit('setTopicsList', topicList);
    },
    cleanTopicsList ({commit}) {
      commit('clearTopicsList');
    },
    toggleTopicHover ({commit}, payload) {
      commit('toggleTopicHover', payload);
    },
    toggleVirtualConditional ({commit}, condition) {
      commit('toggleVirtualConditional', condition);
    },
    resetSelectedTopics ({commit}) {
      commit('resetSelectedTopics');
    },
    resetTopicHover ({commit}) {
      commit('resetTopicHover');
    },
    async removeMapTopicsFromState ({commit}, index) {
      commit('removeMapTopicsFromState', index);
    },
    resetCurrentTopic ({commit}) {
      commit('clearCurrentTopic');
    },
    reSortTopics ({commit}) {
      commit('alphaSortTopics');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/topicsModule.js